import React from 'react';
import { ErrorMessage } from 'formik';

import BasicLabel from 'components/BasicLabel';
import BasicInputFile from 'components/BasicInputFile';
import LinkButton from 'components/LinkButton';
import AvatarWithUpload from 'components/AvatarWithUpload';

const FormStep3 = ({
  values,
  errors,
  touched,
  dirty,
  handleChange,
  handleBlur,
  handleSubmit,
  handleReset,
  isSubmitting,
  setFieldValue,
  setFieldTouched,
  params: { guestResume },
}) => {
  const removeResume = () => {
    setFieldValue('resume', null);
  };

  const selectResume = e => {
    const {
      target: { files },
    } = e;
    const [file = null] = files;
    if (file) {
      setFieldValue('resume', file);
      setFieldTouched('resume', true, true);
    }
  };

  return (
    <div className="form__step">
      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="resume"
            required={false}
            text="Upload Resume"
            styles={{
              fontSize: '0.9286rem',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          />
        </div>
        {guestResume && (
          <p
            className="form__description"
            style={{
              fontSize: '0.9286rem',
              fontFamily: '"Noto Sans", sans-serif',
              fontWeight: '400',
              textTransform: 'none',
              marginBottom: '10px',
            }}
          >
            You have already uploaded a{' '}
            <LinkButton
              text="resume"
              link={guestResume}
              btnFontFamily="Noto Sans, sans-serif"
              btnFontWeight="400"
            />
            {'. '}
            Here you can change it
          </p>
        )}

        <div className="form__control">
          <BasicInputFile
            file={values.resume}
            fieldName={'Resume'}
            onRemoveHandler={removeResume}
            onChangeHandler={selectResume}
            inputStyles={{ marginLeft: '0' }}
            disclaimer="(*doc, *docx, *pdf, *odt, *rtf)"
          />
        </div>

        <ErrorMessage
          name="resume"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '30px' }}>
        <div className="form__row">
          <BasicLabel
            name="picture"
            required={false}
            text="Upload Picture"
            styles={{
              fontWeight: 'bold',
              fontSize: '0.9286rem',
              marginBottom: '10px',
            }}
          />
        </div>

        <p
          className="form__description"
          style={{
            fontSize: '0.9286rem',
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: '400',
            textTransform: 'none',
            marginBottom: '10px',
          }}
        >
          You will be able to continuously update your picture
        </p>

        <AvatarWithUpload
          name="picture"
          image={
            values.picture && values.picture.base64
              ? values.picture.base64
              : null
          }
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />

        <ErrorMessage
          name="picture"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>
    </div>
  );
};

export default FormStep3;
